module.exports = __webpack_public_path__ + "static/media/iconjpeg.2bc48a2e.svg";